import {http} from "../utils/http";


export const getTechnicianGroupListing = async (data) => {
    try {
        return await http.get("TechnicianGroup/list", {
            params: data,
        });
    } catch (error) {
    }
};

export const getTechnicianGroupListingByCases = async (data) => {
    try {
        return await http.get("TechnicianGroup/list-by-cases", {
            params: data,
        });
    } catch (error) {
    }
};

export const getTechnicianGroupListingWithTechnicians = async (data) => {
    try {
        return await http.get("TechnicianGroup/list-with-technicians", {
            params: data,
        });
    } catch (error) {
    }
};

export const getTechnicianGroup = async (data) => {
    try {
        return await http.get("TechnicianGroup", {
            params: data,
        });
    } catch (error) {
    }
};

export const createTechnicianGroup = async (data) => {
    try {
        return await http.post("TechnicianGroup",
            data,
        );
    } catch (error) {
    }
};

export const updateTechnicianGroup = async (id, data) => {
    try {
        return await http.put(`TechnicianGroup`,
            data,
            {params: {id: id}},
        );
    } catch (error) {
    }
};

export const deleteTechnicianGroup = async (ids) => {
    try {
        return await http.delete("TechnicianGroup", {
            data: {
                ids: ids
            }
        });
    } catch (error) {
    }
};